/* eslint-disable @typescript-eslint/no-extraneous-class */

export class MarkdownFormatter {
  // Individual methods for each format type
  static H1(value: string, lineBreaks?: number): string {
    const result = `# ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static H2(value: string, lineBreaks?: number): string {
    const result = `## ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static H3(value: string, lineBreaks?: number): string {
    const result = `### ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static H4(value: string, lineBreaks?: number): string {
    const result = `#### ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static H5(value: string, lineBreaks?: number): string {
    const result = `##### ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static H6(value: string, lineBreaks?: number): string {
    const result = `###### ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static BOLD(value: string, lineBreaks?: number): string {
    const result = `**${value}**`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static ITALIC(value: string, lineBreaks?: number): string {
    const result = `*${value}*`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static BOLD_ITALIC(value: string, lineBreaks?: number): string {
    const result = `***${value}***`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static TEXT(value: string, lineBreaks?: number): string {
    const result = value;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static BULLET_LIST(value: Array<string | number>, lineBreaks?: number): string {
    const result = value.map((item) => `- ${item}`).join('\n');
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static NUMBERED_LIST(value: Array<string | number>, lineBreaks?: number): string {
    const result = value.map((item, index) => `${index + 1}. ${item}`).join('\n');
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static LINK(value: { label: string; url: string }, lineBreaks?: number): string {
    const result = `- [${value.label}](${value.url})`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static CODE(value: string, lineBreaks?: number): string {
    const result = `\`${value}\``;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static CODE_BLOCK(value: string, lineBreaks?: number): string {
    const result = `\`\`\`\n${value}\n\`\`\``;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static QUOTE(value: string, lineBreaks?: number): string {
    const result = `> ${value}`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static HORIZONTAL_RULE(lineBreaks?: number): string {
    const result = `---`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static SUBSCRIPT(value: string, lineBreaks?: number): string {
    const result = `<sub>${value}</sub>`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  static SUPERSCRIPT(value: string, lineBreaks?: number): string {
    const result = `<sup>${value}</sup>`;
    return lineBreaks ? result + this.getLineBreaks(lineBreaks) : result;
  }

  private static getLineBreaks(count: number): string {
    return '\n'.repeat(count);
  }
}
